import React, { useEffect, useRef, useState } from 'react'
import { Link, Redirect } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Label, Form, Alert, Input, FormFeedback } from 'reactstrap';
import PropTypes from "prop-types";
import withRouter from 'components/Common/withRouter';
import { useSelector, useDispatch } from "react-redux";
import { MoonLoader } from "react-spinners";
import * as url from "./../../helpers/url_helper"

const Retrait = props => {
    document.title = "Connexion | Abidjan DAI Application";
    useEffect(()=> {
      const startCamera = async () => {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: "environment" }
          });
          if (videoRef.current) { videoRef.current.srcObject = stream; }
          setHasCamera(true);
        } catch (err) { setError("Erreur lors de l'accès à la caméra: " + err.message); }
      };
  
      startCamera();
  
      return () => {
        if (videoRef.current && videoRef.current.srcObject) {
          const stream = videoRef.current.srcObject;
          const tracks = stream.getTracks();
          tracks.forEach(track => track.stop());
        }
      };
  
    }, []);

    const dispatch = useDispatch();
    const [hasCamera, setHasCamera] = useState(false);
    const [showButton, setShowButton] = useState(true);
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(null);
    const [msgError, setMsgError]= useState("")
    const [opCode, setOpCode]= useState("")
    const [phone, setPhone]= useState("")
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const verifData= ()=>{
      if (phone.trim()==="" || phone.length<8) { setMsgError("Contact agent incorrect"); return false;}
      else if (opCode.trim()==="") { setMsgError("Code de colis obligatoire"); return false;}
      else {return true; }
    }

    const takePhoto = () => {
      const canvas = canvasRef.current;
      const video = videoRef.current;
      const context = canvas.getContext("2d");
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
  
      canvas.toBlob(async (blob) => {
        if (!blob) return;
        const file = new File([blob], "photo.png", { type: "image/png" });
        const formData = new FormData();
        formData.append("file", file);
        if (verifData()) {
          setLoader(true)
          setShowButton(false)
          fetch(url.BACKEND_URL+"/operation/pickup-withimg?opCode="+opCode+"&phone="+phone, {
                method: 'POST', headers: {'Accept': 'application/json' },
                body: formData })
              .then((response) => response.json())
              .then((responseJson) => { console.log(responseJson.data);
                if (responseJson.status==200) { 
                  setLoader(false)
                  setShowButton(true)
                  props.router.navigate('/success-retrait', {state: {operation: responseJson.data}});
              } else { 
                setLoader(false)
                setShowButton(true)
                setMsgError(responseJson.message); 
              }
              }) .catch((error) => { 
                setLoader(false)
                setShowButton(true)
               });
            }
          }, "image/png");     
    };
  

  


  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={12} lg={12} xl={12}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">

                  <div className="p-3">
                    <h4 className="text-muted font-size-18 mb-1 text-center">Retrait de colis</h4>
                    <Form className="form-horizontal mt-2">
                      <div className="mb-3">
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Numéro de l'agent"
                          type="number"
                          onChange={(event)=>setPhone(event.target.value)}
                          value={phone}
                        />
                      </div>
                      <div className="mb-3">
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Code colis"
                          type="text"
                          onChange={(event)=>setOpCode(event.target.value)}
                          value={opCode}
                        />
                      </div>
                      <Row>
                        {error && <p>{error}</p>}
                        {!hasCamera && !error && <p>Chargement de la caméra...</p>}
                        
                        <video ref={videoRef} autoPlay playsInline muted></video>
                        
                        <canvas ref={canvasRef} width={800} height={600} style={{ display: "none" }}></canvas>
                      </Row>
                      {hasCamera ? 
                      (
                        showButton ?
                        (<Row className="mb-3 mt-4">
                        <div className="col-12">
                          <button className="btn btn-primary btn-lg w-md waves-effect waves-light" onClick={takePhoto} style={{ width: '100%' }} type="button"> <i className='fa fa-camera'></i> Prendre photo</button>
                        </div>
                      </Row>): null
                      ): null}
                      <Row>
                        {loader ? (<MoonLoader />): null}
                      </Row>
                      <Row>
                        <strong style={{ fontSize: 17 }} className='text-danger'>{msgError}</strong>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-5 text-center">
                © {new Date().getFullYear()} UE DIGOTAL <span className="d-none d-sm-inline-block"> - <i className="mdi mdi-copyright text-primary"></i> by <a href='https://createsarl.com' target='_blank'>CREATED SARL.</a></span>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

    </React.Fragment>
  )
}

export default withRouter(Retrait);

Retrait.propTypes = {
  history: PropTypes.object,
};
